export const serviceCategories = [
  /* =======================================================
     1) FABRICATION SERVICES
  ======================================================= */
  {
    id: "fabrication-services",
    title: "Fabrication Services",
    shortDesc:
      "High-precision metal fabrication including structural frames, sheet-metal components, generator enclosures, and custom-built industrial assemblies.",

    images: [
      "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzs5m5iUK3C2CdOwDf9aYccwSmuUQCDqwe4PRd1id7Y05M49wmf7MYqkOofJnKONavfzPUp8isa8JECnXlAATNm95OGbZW-k_8slD1kCImgL9ixoxy80tQKP5qRhjayKN2TNPVKbbkCDZQ=s1360-w1360-h1020-rw",
      "https://images.unsplash.com/photo-1581090465321-3fdc0171f1e9",
      "https://images.unsplash.com/photo-1517438984742-1262db08374a",
    ],

    about:
      "Our fabrication division delivers high-strength, engineered metal solutions for industrial, commercial, and power-sector applications. With advanced machinery and certified welders, we provide reliable, durable, and compliant fabricated products tailored to customer specifications.",

    features: [
      "Precision CNC cutting, bending & forming",
      "Expert welding: SMAW, MIG, TIG",
      "Mild Steel, Stainless Steel & Aluminium",
      "Custom acoustic & generator enclosures",
      "Industrial-grade surface treatment & powder coating",
      "Heavy-duty structural frames & platforms",
    ],

    process: [
      "Client requirement & engineering review",
      "3D CAD modelling and approval",
      "Material sourcing & preparation",
      "Welding, forming & fabrication",
      "Surface finishing (sandblasting, painting, coating)",
      "Final inspection & QA compliance",
      "Packing and delivery",
    ],

    capabilities: [
      "CNC plasma cutting up to 25 mm",
      "Heavy-duty MIG & TIG welding",
      "Industrial sheet-metal fabrication",
      "Load-bearing structural steel works",
      "Acoustic & thermal insulation assembly",
      "Modular structures & skid fabrication",
    ],

    standards: [
      "ISO 9001 – Quality Management",
      "EN 1090 – Steel Structure Compliance",
      "AWS D1.1 Welding Standards",
    ],

    applications: [
      "Industrial generator enclosures",
      "Platforms, ladders & access systems",
      "HVAC sheet-metal fabrication",
      "Machinery housings & frames",
      "Skids, bases & custom industrial structures",
    ],

    projectExamples: [
      {
        title: "Custom Steel Platform – Manufacturing Plant",
        image: "https://images.unsplash.com/photo-1581091012184-5c1c7a4fbd02",
        client: "Global Manufacturing LLC",
        link: "#",
      },
      {
        title: "Acoustic Generator Enclosure Fabrication",
        image: "https://images.unsplash.com/photo-1516116216624-53e697fedbea",
        client: "Energy Solutions ME",
        link: "#",
      },
    ],
  },

  /* =======================================================
     2) GENERATOR INSTALLATION
  ======================================================= */
  {
    id: "generator-installation",
    title: "Generator Installation",
    shortDesc:
      "Complete generator installation services including mechanical setup, cabling, ATS/AMF integration, testing and commissioning.",

    images: [
      "https://images.unsplash.com/photo-1509395176047-4a66953fd231",
      "https://images.unsplash.com/photo-1581093458791-9f5f0b4ddc5d",
      "https://images.unsplash.com/photo-1581092787764-0c2a444ef322",
    ],

    about:
      "We provide end-to-end generator installation solutions—from site assessment to final commissioning. Our team installs generators up to 3500 kVA with complete safety compliance and professional engineering standards.",

    features: [
      "Site feasibility & load calculation",
      "Power & control cable laying",
      "ATS/AMF panel integration",
      "Fuel system setup & testing",
      "Vibration pads & base frame alignment",
      "Full electrical & mechanical commissioning",
    ],

    process: [
      "Load study & capacity planning",
      "Base preparation & mounting",
      "Mechanical installation",
      "Electrical cabling & panel integration",
      "Fuel system installation",
      "Testing under load",
      "Commissioning & documentation",
    ],

    capabilities: [
      "Genset installation up to 3500 kVA",
      "Synchronizing panel integration",
      "Acoustic housing installation",
      "Underground & overhead cable routing",
      "Fuel system design & installation",
      "Commissioning and authority approvals",
    ],

    standards: [
      "ISO 9001",
      "Local Civil Defense and Authority Compliance",
      "IEC Electrical Installation Standards",
    ],

    applications: [
      "Commercial buildings",
      "Hospitals & data centers",
      "Construction sites",
      "Industrial power backup",
      "Residential complexes",
    ],

    projectExamples: [
      {
        title: "Hospital Backup Generator Installation",
        image: "https://images.unsplash.com/photo-1581092334451-48322209f94d",
        client: "Sunrise Medical Center",
        link: "#",
      },
      {
        title: "Industrial Synchronizing Panel Setup",
        image: "https://images.unsplash.com/photo-1581091870622-4df4b2a90aea",
        client: "Mega Industries UAE",
        link: "#",
      },
    ],
  },

  /* =======================================================
     3) MAINTENANCE & REPAIR
  ======================================================= */
  {
    id: "maintenance-repair",
    title: "Maintenance & Repair",
    shortDesc:
      "Preventive and corrective maintenance for diesel generators, industrial equipment and power systems.",

    images: [
      "https://images.unsplash.com/photo-1581093588401-9cd1dfab6a7a",
      "https://images.unsplash.com/photo-1581093959966-5c1b32e2f5b3",
    ],

    about:
      "Our maintenance division ensures maximum uptime and reliability with expert diagnostics, fast repairs, and 24/7 emergency support. We maintain generators and industrial systems across all major brands.",

    features: [
      "Engine oil, filter & coolant servicing",
      "Load testing & performance tuning",
      "24/7 breakdown support",
      "Full engine/alternator diagnostics",
      "Fuel system cleaning & calibration",
      "Electrical fault rectification",
    ],

    process: [
      "Initial inspection & problem identification",
      "Advanced testing (electrical/mechanical)",
      "Component repair or replacement",
      "System calibration & tuning",
      "Final load test",
      "Handover with service report",
    ],

    capabilities: [
      "Diesel generator servicing up to 3000 kVA",
      "Vibration analysis & thermal scanning",
      "Alternator rewinding & repair",
      "Fuel & cooling system overhaul",
      "Electrical diagnostics & relay testing",
    ],

    standards: [
      "OEM Maintenance Guidelines",
      "ISO 9001",
      "HSE Work Safety Compliance",
    ],

    applications: [
      "Factories & industrial plants",
      "Commercial buildings",
      "Construction power systems",
      "Emergency power backup",
    ],

    projectExamples: [
      {
        title: "Annual Maintenance – Industrial Power Plant",
        image: "https://images.unsplash.com/photo-1581093956262-3f1cdd192d08",
        client: "National Steel Works",
        link: "#",
      },
      {
        title: "Emergency Breakdown Repair – Commercial Tower",
        image: "https://images.unsplash.com/photo-1581093582496-1c96f2ef749b",
        client: "Skyline Towers",
        link: "#",
      },
    ],
  },

  /* =======================================================
     4) DESIGN & ENGINEERING
  ======================================================= */
  {
    id: "design-engineering",
    title: "Design & Engineering",
    shortDesc:
      "Engineering design services including CAD modelling, structural analysis, enclosure design and acoustic optimization.",

    images: [
      "https://images.unsplash.com/photo-1581090464684-fb19f5ecf1b8",
      "https://images.unsplash.com/photo-1581093638395-2f6afb489f97",
    ],

    about:
      "Our engineering team provides advanced design solutions including CAD modelling, stress analysis, acoustic simulation, and custom engineering for industrial structures and generator housings.",

    features: [
      "3D CAD modelling and assemblies",
      "SolidWorks / Autodesk design solutions",
      "Acoustic & thermal optimization",
      "Structural and vibration analysis",
      "Design documentation & approval drawings",
    ],

    process: [
      "Requirement study & concept proposal",
      "CAD design and simulation",
      "Material selection & optimization",
      "Engineering calculations",
      "Client review & revisions",
      "Final drawings & approval",
    ],

    capabilities: [
      "High-accuracy CAD modelling",
      "FEA (Finite Element Analysis)",
      "Acoustic performance design",
      "Structural load simulations",
      "Custom enclosure engineering",
    ],

    standards: [
      "ISO 9001",
      "CE Compliant Design Standards",
      "ASME & EN Structural Guidelines",
    ],

    applications: [
      "Generator housings & acoustic enclosures",
      "Industrial structural components",
      "Custom equipment engineering",
      "Skids & frames",
    ],

    projectExamples: [
      {
        title: "FEA Design for Generator Enclosure",
        image: "https://images.unsplash.com/photo-1581093638395-2f6afb489f97",
        client: "PowerTech Engineering",
        link: "#",
      },
    ],
  },
];
